// components/ErrorDisplay.jsx
import { Paper, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import React from 'react';

const ErrorDisplay = ({ errors, sx = {} }) => {
    if (!errors || errors.length === 0) return null;

    return (
        <Paper
            elevation={0}
            sx={(theme) => ({
                p: 2,
                mb: 3,
                border: `1px solid ${alpha(theme.palette.warning.main, 0.4)}`,
                borderRadius: 2,
                backgroundColor: alpha(theme.palette.warning.main, 0.08),
                ...sx,
            })}
        >
            <Stack spacing={1}>
                {errors.map((error, index) => (
                    <Typography key={index} variant="body2" color="error">
                        • {JSON.stringify(error, null, 2)}
                    </Typography>
                ))}
            </Stack>
        </Paper>
    );
};

export default ErrorDisplay;
